import { MachineServices } from 'common/bento/types/MachineConfig';
import { apolloClient } from 'common/graphql/clients';

import assertEventType from '../../../../../common/bento/lib/assertEventType';
import { SaveCompanyComplianceDocument } from '../graphql/mutations/saveCompanyCompliance.gql';
import { Model } from './model';

export enum Service {
  SaveCompanyCompliance = 'saveCompanyCompliance',
  SaveActivityOutsideEu = 'saveActivityOutsideEu',
}

const services: MachineServices<Model, Service> = {
  saveActivityOutsideEu: async ({ getModuleData }, event) => {
    assertEventType(event, 'SUBMIT_ACTIVITY_OUTSIDE_EU');

    const { hasActivityOutsideEU } = event.data;

    // Backend handles reset of company sanctions fields if hasActivityOutsideEU is false
    return apolloClient.mutate({
      mutation: SaveCompanyComplianceDocument,
      variables: {
        input: {
          companyProfileId: getModuleData().viewer.company.companyProfileId,
          hasActivityOutsideEU,
        },
      },
    });
  },

  saveCompanyCompliance: async ({ getModuleData }, event) => {
    assertEventType(event, [
      'SUBMIT_COMPANY_MEMBER_SANCTIONS',
      'SUBMIT_COMPANY_SANCTIONS',
    ]);

    return apolloClient.mutate({
      mutation: SaveCompanyComplianceDocument,
      variables: {
        input: {
          companyProfileId: getModuleData().viewer.company.companyProfileId,
          hasActivityOutsideEU: true,
          ...event.data,
        },
      },
    });
  },
};

export default services;
